__webpack_require__.p = "//static.colg.cn/image/colg_answer/";